// extracted by mini-css-extract-plugin
export default {"content":"ListMenu_content__LH7k8","bioKudi":"ListMenu_bioKudi__sLBjS","listHelpInside":"ListMenu_listHelpInside__+XD+9","copyRightTextInside":"ListMenu_copyRightTextInside__47+U8"};